import { Input } from "@/domains/shared/components/Input";
import {
    CARD_EXPIRY_INPUT_PLACEHOLDER,
    formatCardExpiryDisplay,
    normalizeCardExpiryDigits,
} from "@/domains/shared/validation/cardExpiryInput";

type CardExpiryInputProps = {
    value: string;
    onChange: (digits: string) => void;
    placeholder?: string;
    className?: string;
    "data-testid"?: string;
};

export function CardExpiryInput({
    value,
    onChange,
    placeholder = CARD_EXPIRY_INPUT_PLACEHOLDER,
    className,
    "data-testid": dataTestId,
}: CardExpiryInputProps) {
    return (
        <Input
            data-testid={dataTestId}
            inputMode="numeric"
            autoComplete="cc-exp"
            placeholder={placeholder}
            maxLength={5}
            className={className}
            value={formatCardExpiryDisplay(value)}
            onChange={(e) => onChange(normalizeCardExpiryDigits(e.target.value))}
        />
    );
}
